import { useEffect, useState } from 'react';

export function InvitationTools({ inviteLink, copied, onCopy, onNotice }: {
  inviteLink: string;
  copied: boolean;
  onCopy: () => Promise<void>;
  onNotice: (message: string) => void;
}) {
  const [qrOpen, setQrOpen] = useState(false);
  const [qrUrl, setQrUrl] = useState('');

  useEffect(() => {
    if (!qrOpen || !inviteLink) return;
    let cancelled = false;
    void import('qrcode').then(({ toDataURL }) => toDataURL(inviteLink, {
      errorCorrectionLevel: 'M',
      margin: 2,
      width: 280,
      color: { dark: '#09221d', light: '#ffffff' },
    })).then((url) => { if (!cancelled) setQrUrl(url); }).catch(() => onNotice('The invitation QR code could not be generated.'));
    return () => { cancelled = true; };
  }, [inviteLink, onNotice, qrOpen]);

  async function share() {
    if (!navigator.share) {
      await onCopy();
      onNotice('Native sharing is unavailable here, so the private link was copied instead.');
      return;
    }
    try {
      await navigator.share({
        title: 'PairFerry private invitation',
        text: 'Open this private PairFerry invitation while I keep my page open.',
        url: inviteLink,
      });
    } catch (error) {
      if (!(error instanceof DOMException && error.name === 'AbortError')) onNotice('The invitation could not be shared. Copy the private link instead.');
    }
  }

  return <>
    <div className="copy-box"><input readOnly value={inviteLink} aria-label="Private invitation link" /><button className="button secondary" onClick={() => void onCopy()}>{copied ? 'Copied!' : 'Copy link'}</button></div>
    <div className="button-row invitation-actions">
      <button className="button secondary" onClick={() => setQrOpen((open) => !open)}>{qrOpen ? 'Hide QR' : 'Show QR'}</button>
      <button className="button secondary" onClick={() => void share()}>Share invitation</button>
    </div>
    {qrOpen && <div className="qr-card">
      {qrUrl ? <img src={qrUrl} alt="QR code containing this private PairFerry invitation" width="280" height="280" /> : <span>Generating QR code…</span>}
      <p>Scan only on the other trusted device. The QR contains the complete secret invitation and is generated locally in this browser.</p>
    </div>}
  </>;
}
